module.exports = __webpack_public_path__ + "img/home banner_top.46d0507f.jpg";